import { U2000FormStateEnumEditMode } from '../../u2000Core/reducer/formReducer/U2000FormState';
import type { U3120Customer, U3120CustomerType } from '../U3120Service';

export type U3120CustomerSavePayload = Omit<U3120Customer, 'customerCode'> & { customerCode?: string };

export function u3120ResolveCustomerType(
  customerType: U3120Customer['customerType'],
  customerTypes: U3120CustomerType[] | undefined,
): U3120CustomerType | null {
  if (customerType == null) {
    return null;
  }
  if (typeof customerType === 'string') {
    return customerTypes?.find((item) => item.id === customerType) ?? null;
  }
  return customerType;
}

export function u3120ToSavePayload(
  customer: U3120Customer,
  editMode: U2000FormStateEnumEditMode,
  customerTypes?: U3120CustomerType[],
): U3120CustomerSavePayload {
  const payload: U3120CustomerSavePayload = {
    ...customer,
    customerType: u3120ResolveCustomerType(customer.customerType, customerTypes),
    taxable: Boolean(customer.taxable),
  };
  if (editMode === U2000FormStateEnumEditMode.EDIT) {
    const { customerCode: _omit, ...rest } = payload;
    return rest;
  }
  return payload;
}
